import { render } from "./CariAduan.vue?vue&type=template&id=1cad76c9"
import script from "./CariAduan.vue?vue&type=script&lang=js"
export * from "./CariAduan.vue?vue&type=script&lang=js"

import "./CariAduan.vue?vue&type=style&index=0&id=1cad76c9&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__